<template>
  <div>
    <p class="admin-page-description">
      Ficha completa do aluno Quero Pago. Aqui você consulta dados
      pessoais e de contato, contratos vinculados, mensalidades por
      status, pagamentos, dependentes e histórico financeiro — e edita
      informações cadastrais quando necessário.
    </p>
    <div class="student-detail-search">
      <div class="input-group input-group-lg search-student-field">
        <input v-model="search" type="text" class="form-control"
               ref="searchInput" placeholder="Pesquisar aluno por nome, cpf, email ou telefone"
               @keydown.enter="loadStudents"
        >
        <span class="input-group-btn">
          <button class="btn btn-primary" type="button" @click="loadStudents">Pesquisar</button>
        </span>
      </div>
    </div>
    <personal-data />
    <billings-list />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import StudentsService from 'services/StudentsService';
import PersonalData from './PersonalData';
import BillingsList from './BillingsList';


export default {
  data() {
    return {
      search: '',
      students: [],
    };
  },
  components: {
    PersonalData,
    BillingsList,
  },
  mounted() {
    this.loadStudent();
  },
  methods: {
    ...mapActions([
      'loadAllStudentFields',
      'clearStudentData',
    ]),
    loadStudents() {
      StudentsService.getStudents(this.search, 1).then((response) => {
        this.students = response.students;
        if (this.students.length === 1) {
          this.$router.push({ name: 'student-details', params: { id: this.students[0].id } });
          this.clearStudentData();
          this.loadStudent();
        } else {
          this.$router.push({ name: 'students', query: { search: this.search } });
        }
      });
    },
    loadStudent() {
      this.loadAllStudentFields(this.$route.params.id)
        .catch((e) => {
          this.$alert.notifyAlert(`Erro ao carregar os dados do aluno: ${e.message || 'Aluno não encontrado'}`);
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearStudentData();
    next();
  },
};
</script>
